
/* auth */
export const FETCH_AUTH_RESOURCE_REQUEST = 'FETCH_AUTH_RESOURCE_REQUEST'
export const FETCH_AUTH_RESOURCE_SUCCESS = 'FETCH_AUTH_RESOURCE_SUCCESS'
export const FETCH_AUTH_RESOURCE_FAILED = 'FETCH_AUTH_RESOURCE_FAILED'
export const CREATE_MEMBER_AUTH_REQUEST = 'CREATE_MEMBER_AUTH_REQUEST'
export const CREATE_MEMBER_AUTH_SUCCESS = 'CREATE_MEMBER_AUTH_SUCCESS'
export const CREATE_MEMBER_AUTH_FAILED = 'CREATE_MEMBER_AUTH_FAILED'
export const CREATE_MEMBER_AUTH_OTP_REQUEST = 'CREATE_MEMBER_AUTH_OTP_REQUEST'
export const CREATE_MEMBER_AUTH_OTP_SUCCESS = 'CREATE_MEMBER_AUTH_OTP_SUCCESS'
export const CREATE_MEMBER_AUTH_OTP_FAILED = 'CREATE_MEMBER_AUTH_OTP_FAILED'
export const DELETE_MEMBER_AUTH_REQUEST = 'DELETE_MEMBER_AUTH_REQUEST'
export const DELETE_MEMBER_AUTH_SUCCESS = 'DELETE_MEMBER_AUTH_SUCCESS'
export const DELETE_MEMBER_AUTH_FAILED = 'DELETE_MEMBER_AUTH_FAILED'
export const SAVE_REQUIRED_SERVICE = 'SAVE_REQUIRED_SERVICE'
export const CREATE_MEMBER_AUTH_AGAIN_REQUEST = 'CREATE_MEMBER_AUTH_AGAIN_REQUEST'
export const CREATE_MEMBER_AUTH_AGAIN_SUCCESS = 'CREATE_MEMBER_AUTH_AGAIN_SUCCESS'
export const CREATE_MEMBER_AUTH_AGAIN_FAILED = 'CREATE_MEMBER_AUTH_AGAIN_FAILED'
export const SAVE_AUTH_FROM = 'SAVE_AUTH_FROM'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED'

/* Board */
export const FETCH_BOARD_DOCUMENTS_REQUEST = 'FETCH_BOARD_DOCUMENTS_REQUEST'
export const FETCH_BOARD_DOCUMENTS_SUCCESS = 'FETCH_BOARD_DOCUMENTS_SUCCESS'
export const FETCH_BOARD_DOCUMENTS_FAILED = 'FETCH_BOARD_DOCUMENTS_FAILED'
export const FETCH_BOARD_DOCUMENT_REQUEST = 'FETCH_BOARD_DOCUMENT_REQUEST'
export const FETCH_BOARD_DOCUMENT_SUCCESS = 'FETCH_BOARD_DOCUMENT_SUCCESS'
export const FETCH_BOARD_DOCUMENT_FAILED = 'FETCH_BOARD_DOCUMENT_FAILED'

/* Profile */
export const FETCH_LOG_HISTORY_REQUEST = 'FETCH_LOG_HISTORY_REQUEST'
export const FETCH_LOG_HISTORY_SUCCESS = 'FETCH_LOG_HISTORY_SUCCESS'
export const FETCH_LOG_HISTORY_FAILED = 'FETCH_LOG_HISTORY_FAILED'
export const FETCH_USER_INFO_REQUEST = 'FETCH_USER_INFO_REQUEST'
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'
export const FETCH_USER_INFO_FAILED = 'FETCH_USER_INFO_FAILED'
export const FETCH_CHANGE_PASSWORD_REQUEST = 'FETCH_CHANGE_PASSWORD_REQUEST'
export const FETCH_CHANGE_PASSWORD_SUCCESS = 'FETCH_CHANGE_PASSWORD_SUCCESS'
export const FETCH_CHANGE_PASSWORD_FAILED = 'FETCH_CHANGE_PASSWORD_FAILED'
export const FETCH_CHANGE_LATER_REQUEST = 'FETCH_CHANGE_LATER_REQUEST'
export const FETCH_CHANGE_LATER_SUCCESS = 'FETCH_CHANGE_LATER_SUCCESS'
export const FETCH_CHANGE_LATER_FAILED = 'FETCH_CHANGE_LATER_FAILED'
export const CREATE_OTP_REQUEST = 'CREATE_OTP_REQUEST'
export const CREATE_OTP_SUCCESS = 'CREATE_OTP_SUCCESS'
export const CREATE_OTP_FAILED = 'CREATE_OTP_FAILED'
export const DELETE_OTP_REQUEST = 'DELETE_OTP_REQUEST'
export const DELETE_OTP_SUCCESS = 'DELETE_OTP_SUCCESS'
export const DELETE_OTP_FAILED = 'DELETE_OTP_FAILED'
export const CREATE_AGREE_DOCUMENT_REQUEST = 'CREATE_AGREE_DOCUMENT_REQUEST'
export const CREATE_AGREE_DOCUMENT_SUCCESS = 'CREATE_AGREE_DOCUMENT_SUCCESS'
export const CREATE_AGREE_DOCUMENT_FAILED = 'CREATE_AGREE_DOCUMENT_FAILED'

/* Document */
export const FETCH_AGREE_VERSION_REQUEST = 'FETCH_AGREE_VERSION_REQUEST'
export const FETCH_AGREE_VERSION_SUCCESS = 'FETCH_AGREE_VERSION_SUCCESS'
export const FETCH_AGREE_VERSION_FAILED = 'FETCH_AGREE_VERSION_FAILED'
export const FETCH_AGREE_DOCUMENT_REQUEST = 'FETCH_AGREE_DOCUMENT_REQUEST'
export const FETCH_AGREE_DOCUMENT_SUCCESS = 'FETCH_AGREE_DOCUMENT_SUCCESS'
export const FETCH_AGREE_DOCUMENT_FAILED = 'FETCH_AGREE_DOCUMENT_FAILED'
export const FETCH_PRIVACY_VERSION_REQUEST = 'FETCH_PRIVACY_VERSION_REQUEST'
export const FETCH_PRIVACY_VERSION_SUCCESS = 'FETCH_PRIVACY_VERSION_SUCCESS'
export const FETCH_PRIVACY_VERSION_FAILED = 'FETCH_PRIVACY_VERSION_FAILED'
export const FETCH_PRIVACY_DOCUMENT_REQUEST = 'FETCH_PRIVACY_DOCUMENT_REQUEST'
export const FETCH_PRIVACY_DOCUMENT_SUCCESS = 'FETCH_PRIVACY_DOCUMENT_SUCCESS'
export const FETCH_PRIVACY_DOCUMENT_FAILED = 'FETCH_PRIVACY_DOCUMENT_FAILED'
